import React, { useContext } from 'react'
import { DarkModeContext } from '../../../global/Theme';


export default function ThemeSwitcher() {
    const { isDark, toggleDarkMode } = useContext(DarkModeContext);




    return (
        <div className="theme-switcher" onClick={toggleDarkMode}>
            {isDark ? <img style={{cursor: 'pointer'}} src={require('../../../assets/icons/night.svg')} /> : <img style={{cursor: 'pointer'}} src={require('../../../assets/icons/sun.svg')} />}
        </div>
    )
}
